const initialState = {
    statusShow: false,
    validatedFullName: true,
    email: '',
    fullname: '',
    loaderStatus: false,
};
const modalEditProfile = (state = initialState, action) => {
    switch (action.type) {
        case 'OPEN_MODAL_EDIT_PROFILE':
            return {...state, statusShow: true};
        case 'CLOSE_MODAL_EDIT_PROFILE':
            return {...state, statusShow: false};
        case 'CHANGE_INPUTS_MODAL_EDIT_PROFILE':
            return (action.name === 'fullname') ? {
                ...state,
                validatedFullName: (action.value !== ''),
                [action.name]: action.value
            } : {
                ...state,
                [action.name]: action.value
            };
        case 'CHANGE_VALIDATED_MODAL_EDIT_PROFILE':
            return {...state, [action.name]: action.validated};
        case 'LOADER_POST_MODAL_EDIT_PROFILE':
            return {...state, loaderStatus: action.loaderStatus};
        default:
            return state;
    }
};

export default modalEditProfile;